import { render, staticRenderFns } from "./AdminBlockSelector.vue?vue&type=template&id=749a9674"
import script from "./AdminBlockSelector.vue?vue&type=script&lang=ts"
export * from "./AdminBlockSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports